/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useContext,useEffect,useState } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox } from '@material-ui/core';
import { InputLabel } from '@material-ui/core';
import elementValidate from '../Component/validation';
import FormHelperText from '@mui/material/FormHelperText';
import { MasterContext } from '../services/MasterContext';
import { APIGET } from '../services/APIServices';
// import  useStyles  from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
export default function Checkbox(props) {
    const { useStyle } = ThemeControls;
    const classes = useStyle();

    const { field_id, field_label,field_option_src, field_type, field_disabled, field_value_type, field_value, field_check_label, field_helperText, field_mandatory } = props;
    const { handleChange } = useContext(FormContext)
    const [checked, setChecked] = React.useState(field_value == "1" ? true : false);
    const [fieldOptions, setFieldOptions] = React.useState([]);
    let { masterData } = React.useContext(MasterContext);
    const [fieldDisable, setFieldDisable] = useState(field_disabled);
    const field = {
        field_id: field_id,
        field_type: field_type,
        field_disabled: field_disabled,
        field_value: field_value,
        field_helperText: field_helperText,
        field_value_type: field_value_type,
        field_mandatory: field_mandatory,
        field_label: field_label
    }
    function handleBlur() {
        elementValidate(field)
    }

    async function getOptions(props) {
        try {
          if (props.field_option_src_context) {
             
            if (props.field_option_check_local_storage === "true" && (masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`])) {
              setFieldOptions(masterData[`${props.field_option_src_context}`] && masterData[`${props.field_option_src_context}`][`${field_id}`] && masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`]);
               
            }
            else {
              let APIRES = await APIGET(props.field_option_src_context + `/` + props.field_option_src_critieria).then(
                (APIRES) => {
                   
                  let responseArray = new Array();
                  let _i = 0;
                  if (props.field_select_all_label) {
                    let _obj = new Object();
                    _obj.option_label = props.field_select_all_label;
                    _obj.value = props.field_select_all_value;
                    responseArray[_i] = _obj;
                    _i++;
                  }
                  Object.keys(APIRES.data).forEach(key => {
                    let _obj = new Object();
                    function checkType(lableData) {
                      if (typeof lableData === 'string') {
                        _obj.option_label = APIRES.data[key][lableData];
                        _obj.value = APIRES.data[key][props.field_option_value];
                      } else if (Array.isArray(lableData)) {
                        let label = "";
                        for (const item of lableData) {
                          if (item.column) {
                            label += APIRES.data[key][item.column];
                          } else if (item.string) {
                            label += item.string;
                          }
                        }
                        _obj.option_label = label
                      } else {
                        // It's neither a string nor an array.
                         
                      }
                    }
                    function checkValueType(valueData) {
                      if (typeof valueData === 'string') {
                        _obj.value = APIRES.data[key][valueData];
    
                      } else if (Array.isArray(valueData)) {
                        let value = "";
                        for (const item of valueData) {
                          if (item.column) {
                            value += APIRES.data[key][item.column];
                          } else if (item.string) {
                            value += item.string;
                          }
                        }
                        _obj.value = value
                      } else {
                        // It's neither a string nor an array.
                         
                      }
                    }
                    checkType(props.field_option_label)
                    checkValueType(props.field_option_value)
                    // _obj.option_label = APIRES.data[key][props.field_option_label];
                    // _obj.value = APIRES.data[key][props.field_option_value];
                    _obj['attributes'] = {};
                    if (field_option_src.field_option_attributes) {
                      field_option_src.field_option_attributes.map((att) => {
                        _obj['attributes'][`data_${att}`] = APIRES.data[key][att];
                      });
                    }
                    responseArray[_i] = _obj;
                    _i++;
                  })
                  setFieldOptions(responseArray);
                  if (responseArray.length > (field_option_src?.field_Rule_field_disabled || 0)) {
                    setFieldDisable(false);
                    } else {
                        setFieldDisable(true);
                        setChecked(false)
                        handleChange(field_id, {}, 0)

                    }

                  if (masterData[`${props.field_option_src_context}` && `${props.field_option_src_context}`]) {
                    if (masterData[`${props.field_option_src_context}`][`${field_id}`]) {
                      masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                    }
                    else {
                      masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                      masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                    }
                  }
                  else {
                    masterData[`${props.field_option_src_context}`] = {}
                    masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
                    masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = responseArray;
                  }
                  // masterData[`${field_id}_${props.field_option_src_context}_${props.field_option_src_critieria}`] = responseArray;
                }
              );
            }
          }
        } catch (err) {/** TODO Do Nothing */ }
      }
      useEffect(() => {
        if (props?.field_option_src?.field_option_src_critieria) {
          getOptions(field_option_src);
        }
      }, [props?.field_option_src?.field_option_src_critieria])

    React.useEffect(()=>{
        if(field_value == "1"){
            setChecked(true)
        }else{
            setChecked(false)
        }
    },[field_value])

    React.useEffect(()=>{
        setFieldDisable(field_disabled)
    },[field_disabled])

    function handelChecked(value) {
        setChecked(current => !current);
        const _value = value.toString();
        //console.log(value)
        let checkValue = _value === "true" ? "1" : "0";
        handleChange(field_id, {}, checkValue)
    }
    
    return (
        <div className={classes.inputroot}>
            <div style={{ display: "flex" }}>

                <InputLabel className={classes.label}>{field_label}</InputLabel>
                {field_mandatory === "yes" ? <span
                    style={{
                        fontSize: "18px",
                        color: "#d71729",
                        fontWeight: "400",
                        lineHeight: "20px",
                        transform: "translateY(-2px)"
                    }}>{`*`}</span> : null}


            </div>
            <FormControl className={classes.checkBox} disabled={fieldDisable}>
                <FormControlLabel
                    control={<MuiCheckbox
                        id={field_id}
                        // name={name}
                        color="primary"
                        // value={value}
                        checked={checked}
                        onChange={event => handelChecked(event.target.checked)}
                        onBlur={handleBlur}
                    />}
                    label={field_check_label}
                />
            </FormControl>
            <FormHelperText>{field_helperText}</FormHelperText>
        </div>

    )
}
